import React, { useCallback, useState } from 'react';
import { TheaterType, VerifyOwnerState } from '../../../enums';
import { EmailCheckResponse, RegisterNewUserRequest } from '../../../interfaces';
import SelectionOption from './SelectionOption';
import CustomerForm from './customer-form/CustomerForm';
import DellForm from './dell-form/DellForm';
import SkipForm from './skip-form/SkipForm';

export interface OwnerSelectionFormProps {
  projectId: number;
  defaultTheater: TheaterType;
  emailCheckResponse?: EmailCheckResponse;
  registerNewUserRequest?: RegisterNewUserRequest;
  verifyOwnerStateCallback: (state: VerifyOwnerState, value?: unknown) => void;
  onCancel: () => void;
  onSuccess: (state: VerifyOwnerState, email?: string) => void;
}

export const OwnerSelectionForm = (props: OwnerSelectionFormProps) => {
  const [selectionOption, setSelectionOption] = useState<SelectionOption>(SelectionOption.Customer);

  const handleShowOpportunityClick = useCallback(
    (state: VerifyOwnerState, value?: unknown) => {
      props.verifyOwnerStateCallback(state, value);
    },
    [props]
  );

  const handleOptionChange = useCallback(
    (selectionOption: SelectionOption) => {
      setSelectionOption(selectionOption);
      if (selectionOption === SelectionOption.Dell)
        props.verifyOwnerStateCallback(VerifyOwnerState.SelectOwner);
    },
    [props]
  );

  const renderForm = () => {
    switch (selectionOption) {
      case SelectionOption.Dell:
        return (
          <DellForm
            projectId={props.projectId}
            onOptionChange={handleOptionChange}
            onCancel={props.onCancel}
            onSuccess={props.onSuccess}
          />
        );
      case SelectionOption.Skip:
        return (
          <SkipForm
            verifyOwnerStateCallback={handleShowOpportunityClick}
            onCancel={props.onCancel}
            onOptionChange={handleOptionChange}
          />
        );
      case SelectionOption.Customer:
        return (
          <CustomerForm
            projectId={props.projectId}
            defaultTheater={props.defaultTheater}
            emailCheckResponse={props.emailCheckResponse}
            registerNewUserRequest={props.registerNewUserRequest}
            verifyOwnerStateCallback={handleShowOpportunityClick}
            onOptionChange={handleOptionChange}
            onCancel={props.onCancel}
            onSuccess={props.onSuccess}
          />
        );
    }
  };

  return renderForm();
};
